import ResetPassword from './ResetPassword.jsx';

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/modules/reset-password/index.js